import { apiClient } from './apiClient.js'

/****************************************************************************
* 
* Config Templates
* 
***************************************************************************/
export const configTemplateApi = {
    fetchConfigTemplate: async (businessEntityId, configTemplateId, config, accessToken) => {
        const url = `${config.managementApiUrl}/businessentities/${businessEntityId}/configtemplates/${configTemplateId}`
        return await apiClient(
            url,
            accessToken,
            {
                method: "GET"
            },
            async (response) => {
                return await response.json().then(
                    (c) => {
                        return c.configTemplate
                    }
                )
            }
        )
    },
    fetchConfigTemplateList: async (businessEntityId, config, accessToken) => {
        const url = `${config.managementApiUrl}/businessentities/${businessEntityId}/configtemplates`
        return await apiClient(
            url,
            accessToken,
            {
                method: "GET"
            },
            async (response) => {
                return await response.json().then(
                    (c) => {
                        return c.configTemplate
                    }
                )
            }
        )
    },
    createConfigTemplate: async (businessEntityId, configTemplate, config, accessToken) => {
        const url = `${config.managementApiUrl}/businessentities/${businessEntityId}/configtemplates`
        const body = JSON.stringify(configTemplate)
        return await apiClient(
            url,
            accessToken,
            {
                method: "POST",
                body: body
            },
            async (response) => {
                return await response.json().then(
                    (c) => {
                        return c.configTemplate
                    }
                )
            }
        )
    },
    updateConfigTemplate: async (businessEntityId, configTemplate, config, accessToken) => {
        const url = `${config.managementApiUrl}/businessentities/${businessEntityId}/configtemplates/${configTemplate.id}`
        return await apiClient(
            url,
            accessToken,
            {
                method: "PUT",
                body: JSON.stringify(configTemplate)
            },
            async (response) => {
                return await response.json().then(
                    (c) => {
                        return c.configTemplate
                    }
                )
            }
        )
    },
    deleteConfigTemplate: async (businessEntityId, configTemplateId, config, accessToken) => {
        const url = `${config.managementApiUrl}/businessentities/${businessEntityId}/configtemplates/${configTemplateId}`
        return await apiClient(
            url,
            accessToken,
            {
                method: "POST",
                headers: {
                    'X-HTTP-Method-Override': 'DELETE'
                }
            },
            (response) => {
                return response
            }
        )
    },
    applyConfigTemplate: async (businessEntityId, configTemplateId, componentId, config, accessToken) => {
        const url = `${config.managementApiUrl}/businessentities/${businessEntityId}/configtemplates/${configTemplateId}/merge/${componentId}`
        return await apiClient(
            url,
            accessToken,
            {
                method: "POST"
            },
            (response) => {
                return response
            }
        )
    }
}